<template></template>

<script>
import items from "rfuncs/functions/items"

import new_file_from_virtualfile from "../files/make/new_file_from_virtualfile"

export default {
  props: ["filelist"],
  computed: {
    filenames() {
      return items(this.filelist).map(([path, file]) =>
        new_file_from_virtualfile({ path, file })
      )
    },
  },
}
</script>
